import {useEffect} from 'react';
import {normalizeHeights} from '../docViewerUtils';
import {VerticalResizeType} from '../DocView';

export const useVerticalResize = (
  verticalResizeRef: React.RefObject<VerticalResizeType>,
  setLeftHeights: React.Dispatch<React.SetStateAction<number[]>>,
  setRightHeights: React.Dispatch<React.SetStateAction<number[]>>,
  setCodingFormExpandDisabled: React.Dispatch<React.SetStateAction<boolean>>
) => {
  // Vertical Resize between panels inside sections event handlers
  useEffect(() => {
    const onMove = (e: MouseEvent) => {
      if (!verticalResizeRef.current.active) return;
      const {
        side,
        idx = 0,
        startY = 0,
        startHeights = [],
        containerElem,
      } = verticalResizeRef.current;
      if (!containerElem) return;
      const rect = containerElem.getBoundingClientRect();
      const dy = ((e.clientY - startY) / rect.height) * 100;
      const newHeights = [...startHeights];
      const minPanelPercentage = (40 / rect.height) * 100;
      const top = Math.max(minPanelPercentage, (startHeights?.[idx] ?? 0) + dy);
      let bottom = Math.max(minPanelPercentage, startHeights[idx + 1] - dy);
      const origSum = startHeights[idx] + startHeights[idx + 1];
      const actualSum = top + bottom;
      if (actualSum !== origSum) {
        const diff = origSum - actualSum;
        bottom = Math.max(minPanelPercentage, bottom + diff);
      }
      newHeights[idx] = top;
      newHeights[idx + 1] = bottom;
      const normal = normalizeHeights(newHeights, minPanelPercentage);
      if (side === 'left') setLeftHeights(normal);
      else setRightHeights(normal);
      setCodingFormExpandDisabled(false);
    };
    const onUp = () => {
      verticalResizeRef.current.active = false;
      document.body.style.cursor = '';
    };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    return () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
  }, []);
};
